import { BackwardOutlined } from '@ant-design/icons';
import { Form, Button, Layout, Spin, Row, Col, Select } from 'antd';
import React from 'react';
import { map, get, size } from 'lodash';
import { Link } from 'react-router-dom';

import warehouseService from 'api/warehouse.service';
import { upListWarehouse } from 'reducers/auth';
import { getMessage } from 'utils';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { doSelectWh } from 'reducers/auth';
import './login.less';

export const WhSelector = () => {
  const isLoading = useSelector((stores) => stores.auth.isLoading);
  const warehouseList = useSelector((stores) => stores.auth.warehouseList);
  const accessToken = useSelector((stores) => stores.auth.accessToken);
  const history = useHistory();
  const dispatch = useDispatch();

  const handleSubmit = async ({ warehouse_id }) => {
    dispatch(doSelectWh(warehouse_id));
    history.replace('/');
  };

  React.useEffect(async () => {
    const whListRes = await warehouseService.fetchMyWarehouseList(
      {},
      { authorization: 'Bearer '.concat(accessToken) }
    );
    const warehouseList = get(whListRes.data, 'dataList', []);
    dispatch(upListWarehouse({ warehouseList }));
    if (size(warehouseList) === 1) {
      history.replace('/');
    }
  }, []);

  return (
    <Spin spinning={isLoading}>
      <Layout>
        <div
          className={'container'}
          style={{
            backgroundImage: `url('/background.svg')`,
          }}
        >
          <div className={'content'}>
            <div className="container">
              <div className="content">
                <div className="top">
                  <div className="header">
                    <Link to="/">
                      <span className="title">
                        <img height="200" src={'/assets/images/b-logistics.png'} />
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="login" style={{ marginTop: '100px' }}>
                  <Form
                    onFinish={handleSubmit}
                    scrollToFirstError
                    initialValues={{ warehouse_id: '' }}
                  >
                    <Form.Item
                      name="warehouse_id"
                      rules={[
                        {
                          message: getMessage(
                            'pages.common.warehouse_chooser.default_title'
                          ),
                          required: true,
                        },
                      ]}
                    >
                      <Select size="large">
                        <Select.Option value={''}>
                          {getMessage(
                            'pages.common.warehouse_chooser.default_title'
                          )}
                        </Select.Option>
                        {map(warehouseList, (wh) => {
                          return (
                            <Select.Option value={wh.id}>
                              {wh.code} - {wh.name}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                    <Row gutter={24}>
                      <Col span={12}>
                        <Button
                          size="large"
                          icon={<BackwardOutlined />}
                          onClick={() => {
                            localStorage.clear();
                            window.location.href = '/';
                          }}
                          style={{ marginTop: '10px', width: '100%' }}
                        >
                          {getMessage('pages.common.label.go_back')}
                        </Button>
                      </Col>
                      <Col span={12}>
                        <Button
                          type="primary"
                          htmlType="submit"
                          size="large"
                          style={{ marginTop: '10px', width: '100%' }}
                        >
                          {getMessage('pages.common.label.continue')}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </Spin>
  );
};

export default WhSelector;
